import React from 'react';

import {DropdownSwitchView} from './DropdownSwitchView';
import {SavedViewsInfo} from './savedViewUtil';

type SavedViewPrefixProps = {
  savedViewsInfo: SavedViewsInfo;
};

export const SavedViewPrefix = ({savedViewsInfo}: SavedViewPrefixProps) => {
  return (
    // Negative margin to match CallsTable filterbar padding
    <div className="-ml-8">
      <DropdownSwitchView savedViewsInfo={savedViewsInfo} />
    </div>
  );
};
